var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28033 0.21967C0.987437 -0.0732233 0.512563 -0.0732233 0.21967 0.21967C-0.0732233 0.512563 -0.0732233 0.987437 0.21967 1.28033L4.93976 6.00042L0.22003 10.7202C-0.0728634 11.013 -0.0728634 11.4879 0.22003 11.7808C0.512923 12.0737 0.987797 12.0737 1.28069 11.7808L6.00042 7.06108L10.7198 11.7805C11.0127 12.0734 11.4876 12.0734 11.7805 11.7805C12.0734 11.4876 12.0734 11.0127 11.7805 10.7198L7.06108 6.00042L11.7808 1.28069C12.0737 0.987793 12.0737 0.512919 11.7808 0.220026C11.4879 -0.0728672 11.0131 -0.072867 10.7202 0.220026L6.00042 4.93976L1.28033 0.21967Z",
    fill: "#CE0505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed);
export default __webpack_public_path__ + "static/media/CrossRed.1c182d41090bb1276e06ec3ad4626819.svg";
export { ForwardRef as ReactComponent };